itsoftApp.createModule("tooltipBlocks", function () {
    var module = this;

    var initTooltipBlocks = function () {
        let tooltipBlocks = document.querySelectorAll('.page__tooltip-block');

        if (tooltipBlocks) {
            for (let index = 0; index < tooltipBlocks.length; index++) {
                let tooltip = tooltipBlocks[index];
                let tooltipLink = tooltip.querySelector('.page__tooltip-link');
                let tooltipClose = tooltip.querySelector('.page__tooltip-close');
                tooltipLink.addEventListener('click', () => {
                    tooltip.classList.toggle('_active');
                })
                tooltipClose.addEventListener('click', () => {
                    tooltip.classList.remove('_active');
                })
                window.addEventListener('click', function (e) {
                    if (!e.target.closest('.page__tooltip-block')) {
                        tooltip.classList.remove('_active');
                      }
                });

            }
        }
    };

    initTooltipBlocks();

    module.callback = initTooltipBlocks;
});
